
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import RFG from "../../libs/inputs/RFG";
import { useForm } from 'react-hook-form';
import ShareButtons from "../../components/share/ShareButtons";
import { BsArrowLeftSquare, BsEnvelopeAtFill, } from "react-icons/bs";
import SubMenus from "./SubMenus";

const inputStyle = {
    width: '100%', paddingTop: 3, paddingBottom: 3,
    backgroundColor: '#000000a1', color: 'white', border: 'none',
}

export default function ShareBox({ scheduled = { days: ['Mon'], times: [] },
    hideBackBtn = false, keepMenu = [-1], activeView = -1, url,
    icons = [], subject, description, onSubmit = (data) => { }, imgType = "url" }) {
    const [view, setView] = React.useState(activeView)
    const [schedules, setSchedules] = React.useState(scheduled)
    const [message, setMessage] = React.useState("")
    let imgPart = encodeURIComponent(`${url}time=2`);
    const { handleSubmit, control, reset, setValue } = useForm({ defaultValues: { subject: subject, description: description, img_url: imgPart }, mode: "all" })
    React.useEffect(() => { setValue("schedules", schedules) }, [schedules])
    React.useEffect(() => { if (view == 0) setValue("schedules", []) }, [view])
    const chekSubmit = (data) => {
        if (view == 1) {
            if (data?.schedules?.times?.length > 0) {
                onSubmit(data)
            } else {
                setMessage("Scheduled time required")
            }
        } else {
            onSubmit(data, reset)
        }
    }
    return <>
        <Box sx={{ display: 'flex', gap: 1, py: 0, maxWidth: 480, fontSize: 13 }}>
            <Box>
                <Box display={'flex'} sx={{ flexWrap: 'wrap', justifyContent: 'center', rowGap: 2, columnGap: 1 }}>
                    {keepMenu.concat([-1]).includes(view) && (icons || []).map((icon, i) => {
                        return <><Box onClick={() => setView(i)}>{icon}</Box></>
                    })}
                </Box>
                {(!keepMenu.concat([-1]).includes(view) && view !== -1) && <BsArrowLeftSquare sx={{ cursor: 'pointer' }} title="Close" onClick={() => setView(-1)} />}
                {[0, 1].includes(view) && <Box>
                    <Box >
                        <img style={{ borderRadius: '8px' }} width="100%" src={imgType == "url" && !url?.startsWith("data:") ? `${url}?${new Date().getTime()}` : url} onError={(e) => e.target.style.display = "none"} />
                    </Box>
                    <form onSubmit={handleSubmit(chekSubmit)}>
                        <RFG name="to_email" label="Email" control={control} rules={{ required: true, maxLength: 30 }} className="mb-2">
                            <input autoComplete="false" style={inputStyle} />
                        </RFG>
                        <RFG name="subject" label="Subject" control={control} rules={{ required: true, maxLength: 200 }} className="mb-2">
                            <input autoComplete="false" style={inputStyle} />
                        </RFG>
                        <RFG name="description" label="Description" control={control} rules={{ required: true, maxLength: 3000 }} className="mb-2">
                            <input autoComplete="false" style={inputStyle} />
                        </RFG>

                        {view === 1 && <>
                            <Box fontSize={11}>
                                Send recurring email at selected day and time project time until cancelled or project completed
                            </Box>
                            <Box display="flex" gap={0.5} pt={1} flexWrap={'wrap'}>
                                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => {
                                    const currentDays = schedules?.days || [];
                                    const isActive = currentDays.some(d => d === day);
                                    return (
                                        <Typography
                                            key={day}
                                            sx={{
                                                borderRadius: 0.5,
                                                p: 0.5,
                                                width: 30,
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                const updatedDays = isActive
                                                    ? currentDays.filter(d => d !== day) // remove
                                                    : [...currentDays, day]; // add
                                                const updated = { ...schedules, days: updatedDays };
                                                setSchedules(updated);

                                            }}
                                            className={`box ${isActive ? 'active' : ''}`}
                                            fontSize={12}
                                        >
                                            {day}
                                        </Typography>
                                    );
                                })}

                            </Box>
                            <Box pb={1}>
                                <SubMenus position="top" icon={<Typography fontWeight={600} className="btn" fontSize={12}>Time</Typography>}>
                                    <Box px={4} gap={0.5} pt={1} mx={1} maxHeight={100} overflow={'auto'}>
                                        {['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00',
                                            '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00',
                                            '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00',
                                            '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30',
                                        ].map((time) => {
                                            const currentTimes = schedules?.times || [];
                                            const isActive = currentTimes.some(t => t === time);
                                            return (
                                                <Typography
                                                    key={time}
                                                    sx={{
                                                        borderRadius: 0.5,
                                                        p: 0.5,
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        px: 1, my: 0.5
                                                    }}
                                                    onClick={() => {
                                                        const updatedTimes = isActive
                                                            ? currentTimes.filter(t => t !== time) // remove
                                                            : [...currentTimes, time]; // add
                                                        const updated = { ...schedules, times: updatedTimes };
                                                        setSchedules(updated);

                                                    }}
                                                    className={`box ${isActive ? 'active' : ''}`}
                                                    fontSize={12}
                                                >
                                                    {time}
                                                </Typography>
                                            );
                                        })}

                                    </Box>
                                </SubMenus>
                                <Typography sx={{ fontSize: 12, color: 'red' }}>{message}</Typography>
                            </Box>
                        </>}
                        <Box sx={{ mb: 2 }}>
                            <Button sx={{ background: '#1d79f1ff', color: '#fff', px: 1, py: 0, fontSize: 14, textTransform: 'capitalize' }} type="submit" >Submit</Button>
                        </Box>
                    </form>
                    {view === 0 && <ShareButtons shareUrl={url} />}
                </Box>}
            </Box>
        </Box>
    </>
}